import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { api } from '@/lib/api';
import { Lightning, Clock } from '@phosphor-icons/react';

const fmtCountdown = (target) => {
  const diff = new Date(target).getTime() - Date.now();
  if (diff <= 0) return '0m';
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff / 3600000) % 24);
  const m = Math.floor((diff / 60000) % 60);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
};

const EventBanner = () => {
  const [state, setState] = useState({ current: null, next: null });
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    let alive = true;
    const load = () => api.get('/events/current').then(({ data }) => { if (alive) setState(data); }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    const tk = setInterval(() => setNow(Date.now()), 30000);
    return () => { alive = false; clearInterval(t); clearInterval(tk); };
  }, []);

  if (state.current) {
    const e = state.current;
    return (
      <AnimatePresence>
        <motion.div
          data-testid="event-banner-live"
          initial={{ y: -30, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
          className="rounded-2xl p-4 sm:p-5 flex items-center gap-3 relative overflow-hidden"
          style={{ background: `linear-gradient(135deg, ${e.color}33, #00f0ff22)`, borderColor: `${e.color}66`, borderWidth: 1 }}
        >
          <span className="absolute inset-0 opacity-30 pointer-events-none"
                style={{ background: `radial-gradient(circle at 20% 30%, ${e.color}44, transparent 50%)` }} />
          <div className="h-10 w-10 rounded-full grid place-items-center" style={{ background: `${e.color}33` }}>
            <Lightning size={20} weight="fill" style={{ color: e.color }} className="animate-pulse" />
          </div>
          <div className="flex-1 min-w-0 relative z-10">
            <div className="text-[10px] uppercase tracking-widest" style={{ color: e.color }}>LIVE NOW · network-wide</div>
            <div className="font-display text-xl sm:text-2xl font-black tracking-tighter">{e.name}</div>
            <div className="text-white/70 text-xs sm:text-sm">{e.tagline}</div>
          </div>
          <div className="text-right hidden sm:block relative z-10">
            <div className="text-[10px] uppercase tracking-widest text-white/60">ends in</div>
            <div className="font-display font-black text-lg">{fmtCountdown(e.ends_at)}</div>
          </div>
        </motion.div>
      </AnimatePresence>
    );
  }
  if (state.next) {
    const e = state.next;
    return (
      <div data-testid="event-banner-next" className="glass rounded-2xl p-4 flex items-center gap-3">
        <Clock size={18} weight="bold" className="text-bx-cyan" />
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-widest text-white/60">next event</div>
          <div className="font-display font-bold">{e.name} <span className="text-white/60 text-xs ml-1">{e.tagline}</span></div>
        </div>
        <div className="text-right">
          <div className="text-[10px] uppercase tracking-widest text-white/60">in</div>
          <div className="font-display font-black text-bx-cyan">{fmtCountdown(e.starts_at)}</div>
        </div>
      </div>
    );
  }
  return null;
};

export default EventBanner;
